import React from 'react';
import styles from '../Tabs.module.scss';
import PropTypes from 'prop-types';
import uuid from "uuid";

const TabTitle = ({children, id, selected, shy, disabled, clickHandler, ...props}) => {

    const onClickHandler = disabled ? () => null : clickHandler;
    const classes = [styles.tabTitle];
    if (selected) classes.push(styles.tabTitleSelected);
    if (disabled) classes.push(styles.tabTitleDisabled);
    if (shy) classes.push(styles.tabTitleShy);

    return (
        <div className={classes.join(' ')} onClick={onClickHandler} {...props}>
            {children}
        </div>
    );
};

TabTitle.propTypes = {
    children: PropTypes.any,
    title: PropTypes.any,
    clickHandler: PropTypes.func,
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
    shy: PropTypes.bool
};

TabTitle.defaultProps = {
    children: null,
    id: uuid.v4(),
    title: '',
    clickHandler: () => null,
    selected: false,
    disabled: false,
    shy: false
};

export default TabTitle;
